import { Grid } from "@mui/material";
import React from "react";
import "./auction.css";
import AuctionCard from "./AuctionCard";

function Auction() {
  return (
    <div className="auction_main">
      <Grid container justifyContent="center">
        <Grid item xs={11} md={10}>
          {/* NESTED GRID */}
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item xs={12} sm={10} md={6} lg={6}>
              <div className="auction_heading_con">
                <h1 className="auction_heading">Live Auctions</h1>
              </div>
              <div className="autction_para_div">
                <p className="a_para_one">
                  Sign up to receive our monthly newsletter, featuring updates
                  from the team, new decentralized applications and NFT
                  projects, and trends we’re seeing in the space.
                </p>
                <p className="a_para_two">
                  {" "}
                  If you are going to use a passage of Lorem Ipsum, you need to
                  be sure there isn't anything embarrassing.
                </p>
              </div>
              <div className="auction_btn_con">
                <button className="common_btn">View Artwork</button>
              </div>
            </Grid>
            <Grid item lg={5.8}>
              <div className="auction_hero_card">
                <img
                  src="./Assets/auction_1.png"
                  className="img_width"
                  alt=""
                />
                <h2 className="auction_text">Colorful Abstract Painting</h2>
                {/* Nested grid */}
                <Grid
                  container
                  sx={{
                    justifyContent: {
                      xs: "center",
                      sm: "center",
                      md: "space-between",
                    },
                  }}
                >
                  <Grid item lg={8}>
                    <div className="card_flex">
                      <div className="current_bid">
                        <span className="bid_text">current bid</span>
                        <h4 className="bid_price_a">4.77 ETH</h4>
                      </div>
                      <div className="current_bid_two">
                        <span className="bid_text">AUCTION END</span>
                        <h4 className="bid_price_a">56 : 34 : 00</h4>
                      </div>
                    </div>
                  </Grid>
                  <Grid item lg={4}>
                    <button className="common_btn">place bid</button>
                  </Grid>
                </Grid>
                {/* Nested grid */}
              </div>
            </Grid>
          </Grid>
          {/* NESTED GRID */}
          <div className="seprator"></div>
          <div className="seprator"></div>
          <div className="seprator"></div>

          {/* AUCTION CARDS */}
          <AuctionCard />
          {/* AUCTION CARDS */}
        </Grid>
      </Grid>
    </div>
  );
}

export default Auction;
